import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  Separator,
} from "@ac-expo/ui-components";
import UserAvatar from "@ui/components/ui/UserAvatar";
import environment from "@web-app/src/environments/environment";
import { useFileUrlGetter } from "@web-app/src/shared/files";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { SvgWeb } from "../../../public/images/svg/SvgWeb";
import { useUserContext } from "../../context/auth/user.context";
import {
  ClientsIcon,
  GearIcon,
  LifebuoyIcon,
  PresentationIcon,
  ShareIcon,
  SignOutIcon,
  TicketIcon,
  UserIcon,
} from "../../icons";

export const NO_REDIRECT_AT_DISCONNECT_ROUTES = ["/profile/help"];

const UserPopover = () => {
  const [open, setOpen] = useState(false);
  const { getFileUrl } = useFileUrlGetter();
  const { user, disconnect } = useUserContext();
  const router = useRouter();
  const pathname = router.asPath;

  const onDisconnect = () => {
    disconnect();
    if (!NO_REDIRECT_AT_DISCONNECT_ROUTES.includes(pathname)) {
      router.push("/");
    }
  };

  const userImageUrl = getFileUrl(user?.picture?.key, "media");
  const closePopover = () => setOpen(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="flex cursor-pointer gap-4 rounded-full bg-blue-100 fill-blue-700">
          {userImageUrl ? (
            <UserAvatar imgUrl={userImageUrl} className="size-[32px]" />
          ) : (
            <div className="p-2">
              <SvgWeb name="user" alt="user" width={24} height={24} />
            </div>
          )}
        </div>
      </PopoverTrigger>

      <PopoverContent className="mr-12 mt-2 w-[240px] p-0">
        <div className="">
          <Link onClick={closePopover} href={"/profile"}>
            <div className="flex items-center gap-4 px-4 py-3">
              <div className="flex cursor-pointer gap-4 rounded-full bg-blue-100 fill-blue-700">
                {userImageUrl ? (
                  <UserAvatar imgUrl={userImageUrl} className="size-[32px]" />
                ) : (
                  <div className="size-8 p-2">
                    <SvgWeb name="user" alt="user" width={24} height={24} />
                  </div>
                )}
              </div>
              <div className="flex flex-col overflow-hidden">
                <p className="text-sm font-bold">{user?.firstName}</p>
                <p className="truncate text-xs text-gray-500">{user?.email}</p>
              </div>
            </div>
          </Link>
          <Separator />
          <div className="flex flex-col gap-3 px-[10px] py-[9px]">
            <Link onClick={closePopover} href={"/profile"}>
              <div className="flex items-center gap-4">
                <UserIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Mon profil</p>
              </div>
            </Link>
            <Link onClick={closePopover} href={"/profile/mes-billets"}>
              <div className="flex items-center gap-4">
                <TicketIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Mes billets</p>
              </div>
            </Link>
            <Link onClick={closePopover} href={"/profile/my-exhibitors"}>
              <div className="flex items-center gap-4">
                <PresentationIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Mes exposants</p>
              </div>
            </Link>
            <Link onClick={closePopover} href={"/profile/my-favorite-events"}>
              <div className="flex items-center gap-4">
                <TicketIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Mes événements favoris</p>
              </div>
            </Link>
            {user?.isProfessional && (
              <Link onClick={closePopover} href={"/profile/my-clients"}>
                <div className="flex items-center gap-4">
                  <ClientsIcon width={16} height={16} fill={"#287BB9"} />
                  <p className="text-sm text-gray-700">Mes clients</p>
                </div>
              </Link>
            )}
            <Link onClick={closePopover} href={"/profile/my-settings"}>
              <div className="flex items-center gap-4">
                <GearIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Mes paramètres</p>
              </div>
            </Link>
            <Link onClick={closePopover} href={"/profile/help"}>
              <div className="flex items-center gap-4">
                <LifebuoyIcon width={16} height={16} fill={"#287BB9"} />
                <p className="text-sm text-gray-700">Aide</p>
              </div>
            </Link>
          </div>
          {user?.isProfessional && (
            <>
              <Separator />
              <Link
                onClick={closePopover}
                href={environment.BACKOFFICE_URL}
                target="_blank"
                className="flex flex-col gap-3 px-[10px] py-[9px]"
              >
                <div className="flex items-center gap-4">
                  <ShareIcon width={16} height={16} fill={"#287BB9"} />
                  <p className="text-sm text-gray-700">
                    Accéder à mon back office
                  </p>
                </div>
              </Link>
            </>
          )}
          <Separator />
          <div className="flex px-[10px] py-[9px]">
            <button onClick={onDisconnect} className="flex items-center gap-2">
              <SignOutIcon width={16} height={16} fill={"#98A2B3"} />
              <p>Se déconnecter</p>
            </button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default UserPopover;
